import {Observable} from 'rxjs';
import {HttpService} from '@services/http.service';
import {environment} from '@env/environment';
import {Injectable} from '@angular/core';

export interface Request {
  id: number;
  label: string;
  code: string;
  state: any,
  date: string;
}

export interface Response {
  status: string;
  data: any
}

export interface ResponsePost {
  result: Response
}


@Injectable({
  providedIn: 'root'
})
export class ApiService {


  constructor(
    private http: HttpService
  ) {
  }

  public login(login: string, password: string): Observable<any> {
    return this.http.post(environment.api.BE + "/user/login", {login, password});
  }

  public getRequest(id: number) {
    return this.http.get(environment.api.BE+`/hr/request/${id}`);
  }

  public getRequests(mail: string | undefined, data: { name: string, code: string, state: string, date_from: string, date_to: string, order?: string, direction?: "asc" | "desc"  } | {} ) {
    return this.http.post<ResponsePost>(environment.api.BE+`/hr/${mail}/request/list`, data);
  }

  public integrateRequest(data: any) {
    return this.http.post(environment.api.BE+`/hr/request/integrate`, data)
  }

  public createRequest(data: any) {
    return this.http.post(environment.api.BE+`/hr/request/create`, data)
  }

  public getExerciseTypes() {
    return this.http.get<Response>(environment.api.BE+`/hr/exerciseType/list`);
  }
  public getRequestTypes() {
    return this.http.get<Response>(environment.api.BE+`/hr/requestType/list`);
  }

  public getDocument(id: number) {
    return this.http.get(environment.api.metafora+`/documents/document-content/${id}`)
  }

  public getDocumentTmp(id: number) {
    return this.http.get(environment.api.BE+`/hr/document/${id}`)
  }

  public getProcedures(data: { name: string, code: string, date_from: string, date_to: string, order?: string, direction?: "asc" | "desc"  } | {} ) {
    return this.http.post<ResponsePost>(environment.api.BE+`/hr/procedure/list`, data);
  }

  public getProcedure(id: number) {
    return this.http.get(environment.api.BE+`/hr/procedure/${id}`);
  }

  public getImsDocuments(data: { name: string, order?: string, direction?: "asc" | "desc"  } | {} ) {
    return this.http.post<ResponsePost>(environment.api.BE+`/ims/documents/list`, data);

    // const resp: Response = {
    //   status: "success",
    //   data: [
    //     {
    //       document_id: 4568,
    //       filename: "MC Test 2_Procedura operativa_rev_1.pdf",
    //       mimetype: "application/pdf",
    //       size: 62488,
    //       write_date: "18/11/2025"
    //     },
    //     {
    //       document_id: 4566,
    //       filename: "O.SG.0011_Procedura operativa_rev_1.pdf",
    //       mimetype: "application/pdf",
    //       size: 62488,
    //       write_date: "18/11/2025"
    //     }
    //   ]
    // }
    //
    // const mock: ResponsePost = {
    //   result: resp
    // }

    // return of(mock)
  }

  public getImsDocumentTypes() {
    return this.http.get<Response>(environment.api.BE+`/ims/documentType/list`);
    // const resp: Response = {
    //   status: "success",
    //   data: [
    //     {
    //       id: 1,
    //       label: "Istruzione Operativa"
    //     },
    //     {
    //       id: 2,
    //       label: "Procedura Operativa"
    //     }
    //   ]
    //
    // }
    // return of(resp);
  }



}
